<template>
  <v-list-item
    :class="{ 'blue lighten-3': isSelected }"
    :to="item.to"
    exact
    @click="$emit('click')"
  >
    <v-list-item-action class="mr-4">
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>
        <span
          v-for="(label, idx) in labelPieces"
          :key="idx"
          class="mr-6"
          :class="label.cssClass"
        >
          {{ label.text }}
        </span>
      </v-list-item-title>
      <v-list-item-subtitle v-if="detailsMode">
        <OTagList
          class="small"
          style="opacity: 0.7; flex-flow: row nowrap"
          :value="item.details"
        />
      </v-list-item-subtitle>
      <v-list-item-subtitle v-else-if="showingTags">
        <OTagList
          class="small"
          style="opacity: 0.7; flex-flow: row nowrap"
          :value="item.tags"
        />
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="item.rightLabel">
      <v-chip small>
        {{ item.rightLabel }}
      </v-chip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import OTagList from 'oderon-vue/cpts/OTagList.vue'
import utils from 'oderon-commons/src/utils.js'

export default {
  components: { OTagList },
  props: {
    isSelected: { type: Boolean, default: false },
    item: { required: true },
    detailsMode: {},
  },
  computed: {
    showingTags() {
      if ( this.detailsMode ) return false
      if ( this.item.tags == null || this.item.tags.length < 1 ) return false
      return true
    },
    labelPieces() {
      let pieces = this.item.label
      if (!Array.isArray(pieces)) pieces = [pieces]

      pieces = pieces.map((p) => {
        if (utils.isBlank(p)) return null
        if (utils.isString(p)) return { text: p }
        return p
      })

      return pieces.filter((p) => p != null && !utils.isBlank(p.text))
    }
  }
}
</script>

<style></style>
